import { Box, Avatar, Typography } from '@mui/material';
import CheckboxMultipleFillIcon from 'remixicon-react/CheckboxMultipleFillIcon';
import { styled, useTheme } from '@mui/material/styles';
import { DotSeparatedList } from '@buildwise/libs/ui';
import { TrackerType } from '@buildwise/libs/trackers/apis/TrackerAPI';
import CheckboxLineIcon from 'remixicon-react/CheckboxLineIcon';
import { Link as RouterLink } from 'react-router-dom';
import { TRACKER_DETAILS } from 'constants/routes';

export type TrackerItemProps = {
  tracker: TrackerType;
};

const TrackerItem = ({ tracker }: TrackerItemProps) => {
  const theme = useTheme();

  return (
    <Link to={TRACKER_DETAILS.replace(':trackerId', tracker.id)}>
      <TrackerContainer>
        <Avatar
          sx={{
            bgcolor: theme.palette.custom.tropicalBlue,
            mr: 2,
            width: 40,
            height: 40,
          }}
          variant="rounded"
        >
          <CheckboxMultipleFillIcon color={theme.palette.custom.black} />
        </Avatar>
        <Box flex={1}>
          <TrackerName>{tracker.name}</TrackerName>
          {tracker.description && <TrackerInfo>{tracker.description}</TrackerInfo>}
          <DotSeparatedList
            sx={{ mt: 1 }}
            items={[
              tracker.taskCount && (
                <>
                  <CheckboxLineIcon size={18} />
                  &nbsp;
                  {tracker.taskCount} {tracker.taskCount === 1 ? 'Task' : 'Tasks'}
                </>
              ),
            ]}
          />
        </Box>
      </TrackerContainer>
    </Link>
  );
};

const TrackerContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: 16,
  display: 'flex',
  cursor: 'pointer',
  backgroundColor: theme.palette.custom.white,
  marginTop: 1,
  borderRadius: 8,
}));

const TrackerName = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 16,
  lineHeight: '19.2px',
  marginBottom: 2,
  cursor: 'pointer',
  width: 'fit-content',
  display: 'block',
  '&:hover': {
    textDecoration: 'underline',
    color: theme.palette.custom.link,
  },
}));

const TrackerInfo = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.custom.slate,
  marginTop: 2,
}));

const Link = styled(RouterLink)(({ theme }) => ({
  display: 'block',
  textDecoration: 'none',
  color: 'inherit',
  width: '100%',
  '&:hover': {
    textDecoration: 'none',
  },
}));

export default TrackerItem;
